import Repository from './Repository';

class DeviceTypeRepository extends Repository {
	/**
	 * Resolves an array of client objects from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async all () {
		return this.getWithToken('/device-types');
	}

	/**
	 * Resolves an array of device types from the given client ID.
	 *
	 * @param {int} clientId The client ID to filter
	 * @param {boolean} withAttributes (Optional) With DeviceTypeAttributes?
	 *	Default is false
	 * @returns {Promise<array>}
	 */
	async getFromClient (clientId, withAttributes = false) {
		let url = `/clients/${clientId}/device-types`;

		if (withAttributes) {
			url += '?withAttributes=true';
		}

		return this.getWithToken(url);
	}
}

export default new DeviceTypeRepository();
